import {Injectable, inject} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from '@services/api/api.service';
import {ApiResponse} from '@interfaces/response';
import {Room} from '@interfaces/room';
import {environment} from '@environment/environment';

@Injectable({
  providedIn: 'root'
})
export class RoomsService {

  private list_room_url = '/videochat/rooms';

  private api_service: ApiService = inject(ApiService);

  constructor() {
  }

  public getRooms(showLoader: boolean = true): Observable<ApiResponse<Room[]>> {
    return this.api_service.get<ApiResponse<Room[]>>(this.list_room_url, undefined, undefined, showLoader);
  }

  public getRoomsPromise(): Promise<ApiResponse<Room[]>> {
    return this.api_service.get<ApiResponse<Room[]>>(this.list_room_url, null, {}, false).toPromise();
  }

  public getRoom(id: string | number, showLoader: boolean = true): Observable<ApiResponse<Room>> {
    const url = `${this.list_room_url}/${id}`;
    return this.api_service.get<ApiResponse<Room>>(url, undefined, undefined, showLoader);
  }

  public getRoomPromise(id: string | number): Promise<ApiResponse<Room>> {
    const url = `${this.list_room_url}/${id}`;
    return this.api_service.get<ApiResponse<Room>>(url).toPromise();
  }

  public getRoomActive(showLoader: boolean = true): Observable<any> {
    return this.api_service.getExternalUrl(environment.api.url_connect_check, undefined, undefined, showLoader);
  }

  public getRoomActivePromise(): Promise<any> {
    return this.api_service.getExternalUrl(environment.api.url_connect_check, null, {}, false).toPromise();
  }

}
